/**
 * Example:
 * Input: "/home/user/documents/file.txt"
 * Output: "home > user > documents >"
 *
 * @param {string} path - The file path to transform.
 * @returns {string} - The transformed breadcrumb-like string.
 */
export const transformPath = (path: string): string => {
    const parts = path.split("/");
    const relevantParts = parts.slice(0, -1).join("/");
    return relevantParts.replaceAll("/", " > ") + " >";
};
